export default "__VITE_ASSET__BCz8txqV__"